<template>
    <div class="main">
		<h1><p>{{this.$store.state.project.project_name}}</p>
			<label class="test">输入测试</label>
		</h1>
		<div class="content">
			<div class="right">
				<div class="title" style="text-align:left;">应试人员信息</div>
				<div class="details">
					<img src="@/assets/image/message/tou.png" alt="">
					<div>
						<p>姓名</p>
						<div>{{this.$store.state.user.user_name || 'xxx'}}</div>
					</div>
					<div>
						<p>准考证号</p>
						<div>{{this.$store.state.user.exam_no || '111111111111111'}}</div>
					</div>
					<div>
						<p>证件号码</p>
						<div>{{this.$store.state.user.user_id_no || '111111111111111111'}}</div>
					</div>
					<div>
						<p>机位号</p>
						<div class="seat">001</div>
					</div>
				</div>
			</div>
			<div class="left">
				<div class="title">请选择输入法并测试输入结果</div>
				<div class="change">
					当前输入法：搜狗拼音输入法
					<a href="javascript:;" class="btn">切换输入法</a>
				</div>
				<!-- <div>输入法切换快捷方式：CTRL+SHIFT <br>阿语按左边“CTRL+SHIFT”组合键或右边“CTRL+SHIFT”组合键，可切换文本对齐方式</div> -->
				<div class="item">
					<textarea name="" id="" cols="30" rows="10"></textarea>
				</div>
				<a href="javascript:;" class="btn pass" @click="pass">测试通过</a>
				<a href="javascript:;" class="btn nopass">测试不通过</a>
			</div>
		</div>
	</div>
</template>
<script>
export default {
    name: '',
    components: {},
    data() {
        return {
        }
    },
    methods: {
        pass(){
            this.$router.push({name:"Message",params:{project_code:this.$store.state.project.project_code}});
        }
    },
}
</script>
<style lang='scss' scoped src="../assets/css/test.scss"></style>
<style lang="scss" scoped>
textarea{width: 100%;
    resize: none;
    margin: 10px 0;
    padding: 10px;
    box-sizing: border-box;}
</style>
